import { Head, Link } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import SearchFilter from '@/Shared/SearchFilter';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Link: Link,
    SearchFilter: SearchFilter
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array
  },
  data: function data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed
      }
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/users', pickBy(this.form), {
          preserveState: true
        });
      }, 150)
    }
  },
  methods: {
    reset: function reset() {
      this.form = mapValues(this.form, function () {
        return null;
      });
    }
  }
};